import { StatisticType } from '../enums/statistic-type.enum';
import { StatisticApiPayload } from './statistic-api.model';

/**
 * Domain payload sent to the statistics endpoint.
 *
 * `region` defaults to '' for the types that do not carry a region per spec
 * (`articles` and `features`).
 */
export class StatisticPayload {
  type: StatisticType;
  code: string;
  name: string;
  region: string;

  constructor(params: {
    type: StatisticType;
    code: string;
    name: string;
    region: string;
  }) {
    this.type = params.type;
    this.code = params.code;
    this.name = params.name;
    this.region = params.region ?? '';
  }

  toApi(): StatisticApiPayload {
    return {
      type: this.type,
      code: this.code,
      name: this.name,
      region: this.region,
    };
  }

  /**
   * De-duplication key — combines type + code + name so the same statistic
   * event does not fire twice within a single view session. `name` is part
   * of the key because the `customers` trigger dispatches twice for the
   * same `(type, code)` (broker name + agency name) and both must be
   * tracked independently.
   */
  get dedupKey(): string {
    return `${ this.type }:${ this.code }:${ this.name }`;
  }
}
